import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/caprock/images/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-12f876fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "right-sidebar",
  tabindex: "1",
  style: {"overflow":"auto","z-index":"1!important"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"80px"} }, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card-body dashboard-card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 pl-2 h-100 pr-15" }
const _hoisted_8 = { class: "m-0 p-0 font-size-13 float-right dash-ac-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  class: "m-0 p-0 font-size-16 float-right dash-ac-balance",
  style: {}
}
const _hoisted_11 = { id: "paymaster_balance" }
const _hoisted_12 = {
  key: 0,
  class: "col-12 p-0",
  id: "paymaster_chartBody"
}
const _hoisted_13 = {
  id: "chart",
  style: {"height":"80px"}
}
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "row right-side-total" }
const _hoisted_16 = { class: "col-6 pr-0" }
const _hoisted_17 = {
  class: "font-size-13 font-grey",
  id: "total_balance"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 p-0 text-right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-size-13 font-grey" }, "Total Portfolio")
], -1))
const _hoisted_19 = { class: "main-content" }
const _hoisted_20 = { class: "section" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-9 col-md-9 col-sm-9 text-left align-items-center" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4",
  src: "https://map.admin.caprock.com.au/inlancer-admin/images/dashboard.svg",
  style: {"height":"18px"}
}, null, -1))
const _hoisted_25 = { class: "font-size-16 font-grey" }
const _hoisted_26 = {
  key: 0,
  class: "col-lg-3 col-md-3 col-sm-3 text-right align-items-right"
}
const _hoisted_27 = {
  class: "font-size-14",
  style: {"font-weight":"300","color":"#899aa9 !important","letter-spacing":"1.5px"}
}
const _hoisted_28 = { style: {"border":"1px solid #a5a4a438","padding":"4px 10px"} }
const _hoisted_29 = { class: "tab-content w-100" }
const _hoisted_30 = {
  class: "tab-pane fade show active",
  id: "v-pills-home",
  role: "tabpanel",
  "aria-labelledby": "v-pills-home-tab"
}
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-12 mt-4" }
const _hoisted_35 = {
  class: "p-4 bg-white border-radius-10 text-left",
  style: {"min-height":"340px"}
}
const _hoisted_36 = { class: "row multi_asset_row" }
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-12f876fc><div class=\"col-12 col-md-6\" data-v-12f876fc><b data-v-12f876fc>Strategy</b></div><div class=\"col-4 col-md-2 text-right\" data-v-12f876fc><b data-v-12f876fc>Type</b></div><div class=\"col-4 col-md-2 text-right\" data-v-12f876fc><b data-v-12f876fc>Growth</b></div><div class=\"col-4 col-md-2 text-right\" data-v-12f876fc><b data-v-12f876fc>Defensive</b></div></div>", 1)
const _hoisted_39 = {
  class: "row",
  style: {"border-top":"3px solid grey"}
}
const _hoisted_40 = { class: "col-12 col-md-6" }
const _hoisted_41 = { class: "col-4 t_b col-md-2 text-right" }
const _hoisted_42 = { class: "" }
const _hoisted_43 = { class: "col-4 t_b col-md-2 text-right" }
const _hoisted_44 = { class: "" }
const _hoisted_45 = { class: "col-4 t_b col-md-2 text-right" }
const _hoisted_46 = { class: "" }
const _hoisted_47 = {
  class: "row",
  style: {"border-top":"2px solid grey","margin-top":"15px","padding-top":"5px"}
}
const _hoisted_48 = { class: "col-12 col-md-12" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "FUND OBJECTIVE & PROCESS", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = {
  class: "row",
  style: {"border-top":"2px solid grey","margin-top":"15px","padding-top":"5px"}
}
const _hoisted_52 = { class: "col-12 col-md-12 table-responsive" }
const _hoisted_53 = { class: "table table-bordered" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Platform", -1))
const _hoisted_55 = { class: "font-dark" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Code", -1))
const _hoisted_57 = { class: "font-dark" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Min investment", -1))
const _hoisted_59 = { class: "font-dark" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Investment Manager", -1))
const _hoisted_61 = { class: "font-dark" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Subadvisor", -1))
const _hoisted_63 = { class: "font-dark" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Risk profile ", -1))
const _hoisted_65 = { class: "font-dark" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Risk rating", -1))
const _hoisted_67 = { class: "font-dark" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Fund type", -1))
const _hoisted_69 = { class: "font-dark" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Investments", -1))
const _hoisted_71 = { class: "font-dark" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "SMA Fees", -1))
const _hoisted_73 = { class: "font-dark" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Investment Manager Fees", -1))
const _hoisted_75 = { class: "font-dark" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Sub Advisor Fees", -1))
const _hoisted_77 = { class: "font-dark" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "30%",
  class: "font-dark"
}, "Strategy inception date ", -1))
const _hoisted_79 = { class: "font-dark" }
const _hoisted_80 = {
  key: 0,
  class: "row",
  style: {"border-top":"2px solid grey","margin-top":"15px","padding-top":"5px"}
}
const _hoisted_81 = { class: "col-12 col-md-6" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "CURRENT TARGET ALLOCATION", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_84 = { class: "table-responsive w-100" }
const _hoisted_85 = { class: "table table-bordered border-none w-100" }
const _hoisted_86 = {
  width: "80%",
  class: "font-dark"
}
const _hoisted_87 = { class: "font-dark" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "80%",
  class: "font-dark"
}, "Total Allocation", -1))
const _hoisted_90 = { class: "font-dark" }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "text-center"
}, "No records found", -1))
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Risk Profile", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_97 = { class: "table-responsive w-100" }
const _hoisted_98 = { class: "table table-bordered border-none w-100" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "80%",
  class: "font-dark"
}, "Growth", -1))
const _hoisted_100 = { class: "font-dark" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "80%",
  class: "font-dark"
}, "Defensive", -1))
const _hoisted_102 = { class: "font-dark" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    width: "80%",
    class: "font-dark"
  }, "Total"),
  /*#__PURE__*/_createElementVNode("td", { class: "font-dark" }, "100 %")
], -1))
const _hoisted_104 = { class: "col-12 col-md-6 text-center" }
const _hoisted_105 = { class: "text-center" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = { class: "text-center" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = { id: "chart1" }
const _hoisted_110 = {
  key: 1,
  class: "row",
  style: {"border-top":"2px solid grey","margin-top":"15px","padding-top":"5px"}
}
const _hoisted_111 = { class: "col-12 col-md-12" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "HISTORICAL PERFORMANCE", -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_114 = { id: "chart2" }
const _hoisted_115 = {
  key: 2,
  class: "row",
  style: {"margin-top":"20px","padding-top":"5px"}
}
const _hoisted_116 = { class: "col-12 col-md-12" }
const _hoisted_117 = {
  class: "row",
  style: {"margin-top":"15px","border-radius":"5px","padding-top":"5px","background":"#f1f1f1"}
}
const _hoisted_118 = { class: "col-12 col-md-12" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Disclaimer", -1))
const _hoisted_120 = { class: "col-12 col-md-ms_copyright" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Copyright", -1))
const _hoisted_122 = { class: "row justify-content-center mx-md-0 mx-1 mb-1 mt-0" }
const _hoisted_123 = { class: "col-md-3 col-12 px-1" }
const _hoisted_124 = ["href"]
const _hoisted_125 = { class: "col-12 mt-4" }
const _hoisted_126 = { class: "p-4 bg-white border-radius-10 text-left" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-size-14 dash-map-title" }, " Documents ")
], -1))
const _hoisted_128 = { class: "font-size-14 font-grey" }
const _hoisted_129 = ["href"]
const _hoisted_130 = ["title"]
const _hoisted_131 = {
  style: {"height":"25px","width":"25px"},
  width: "752pt",
  height: "752pt",
  "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
  "sodipodi:docname": "d-icon.svg",
  version: "1.1",
  viewBox: "0 0 752 752",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
  "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "grey",
  d: "m552.19 261.61c-13.464-77.229-80.529-135.11-160.89-135.11-64.695 0-122.75 38.124-148.96 96.303-1.6582-0.0793-3.3005-0.11901-4.935-0.11901-54.395 0-101.6 34.545-118.49 85.298-66.71 21.905-112.37 84.171-112.37 155.18 0 90.171 73.357 163.52 163.52 163.52h394.38c100.78 0 182.76-81.981 182.76-182.76 0-104.84-88.648-189.85-195.01-182.32zm-160.89 297.74-125.04-134.66h76.952v-86.568h96.191v86.568h76.952z",
  "stroke-width": "2.0311",
  "inkscape:connector-curvature": "0"
}, null, -1))
const _hoisted_133 = {
  key: 0,
  style: {"margin-left":"10px","padding-bottom":"4px"}
}
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-size-14 font-grey" }, " No Document Found ", -1))
const _hoisted_135 = [
  _hoisted_134
]
const _hoisted_136 = { class: "col-12 mt-4" }
const _hoisted_137 = {
  class: "bg-white border-radius-10 text-left mb-4",
  style: {"padding":"20px"}
}
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dash-map-title font-size-14 mb-0" }, " Terms & Conditions / Descriptions ", -1))
const _hoisted_139 = {
  style: {"color":"#908a8a","margin-left":"10px"},
  class: "pre-formatted"
}
const _hoisted_140 = { class: "col-12 mt-4" }
const _hoisted_141 = {
  class: "bg-white border-radius-10 text-left mb-4",
  style: {"padding":"10px"}
}
const _hoisted_142 = {
  class: "login-card bg-white p-4",
  style: {"border-radius":"6px"}
}
const _hoisted_143 = { class: "login-body" }
const _hoisted_144 = { class: "form-group mt-1 mb-0" }
const _hoisted_145 = { class: "dash-map-title font-size-16 mb-0" }
const _hoisted_146 = { class: "label float-right" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_148 = { class: "row" }
const _hoisted_149 = { class: "form-group col-md-6" }
const _hoisted_150 = { class: "form-group col-md-6" }
const _hoisted_151 = { class: "form-group col-md-6" }
const _hoisted_152 = { class: "form-group col-md-6" }
const _hoisted_153 = { class: "form-group col-md-6" }
const _hoisted_154 = { class: "form-group mt-1 mb-0" }
const _hoisted_155 = {
  style: {"height":"15px","width":"15px","margin":"5px"},
  width: "100mm",
  height: "100mm",
  version: "1.1",
  viewBox: "0 0 100 100"
}
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m139.21 139.21h473.58v473.58h-473.58z",
      "inkscape:connector-curvature": "0"
    })
  ])
], -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  transform: "translate(0,-197)",
  "inkscape:groupmode": "layer",
  "inkscape:label": "Layer 1"
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(1.6371 0 0 1.6371 16.358 -155.86)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m-8.417 217.52h57.655v57.655h-57.655z",
      fill: "none",
      stroke: "#000",
      "stroke-miterlimit": "10",
      "stroke-width": "1.6707",
      "inkscape:connector-curvature": "0"
    }),
    /*#__PURE__*/_createElementVNode("g", {
      transform: "matrix(.35278 0 0 .35278 -152.74 113.7)",
      "clip-path": "url(#a)"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        transform: "matrix(4.7358,0,0,4.7358,139.21,139.21)",
        d: "m64.04 52.74 6.31 6.9806 13.98-20.311",
        fill: "none",
        stroke: "#000",
        "stroke-linecap": "square",
        "stroke-miterlimit": "10",
        "stroke-width": "5",
        "inkscape:connector-curvature": "0"
      })
    ])
  ])
], -1))
const _hoisted_158 = {
  style: {"height":"15px","width":"15px","margin":"5px"},
  width: "100mm",
  height: "100mm",
  viewBox: "0 0 100 100"
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m139.21 139.21h473.58v473.58h-473.58z",
      "inkscape:connector-curvature": "0"
    })
  ])
], -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  transform: "translate(0,-197)",
  "inkscape:groupmode": "layer",
  "inkscape:label": "Layer 1"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m2.5789 200.25h94.389v94.389h-94.389z",
    fill: "none",
    stroke: "#000",
    "stroke-miterlimit": "10",
    "stroke-width": "2.7351",
    "inkscape:connector-curvature": "0"
  })
], -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "I confirm I have read the Information Memorandum and agree to the Terms & Conditions", -1))
const _hoisted_162 = { class: "errorMsg danger ml-2" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  style: {"color":"#313731"},
  class: "mt-2"
}, "ELECTRONIC EXECUTION", -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px","color":"#313731","display":"inline-block"} }, [
  /*#__PURE__*/_createTextVNode(" A party may sign electronically a soft copy of this document and any future amendments or variations of this document through the digital 'click' acceptance via the Platform or by signing this document by some other electronic method (including signing by stylus or pasting of the signatory's signature) and bind itself accordingly. This will satisfy any statutory or other requirements for this document to be in writing and signed by that party. The parties intend that: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "any soft copy so signed will constitute an executed original counterpart, and any print-out of the copy with the relevant signatures appearing will also constitute an executed original counterpart; and"),
    /*#__PURE__*/_createElementVNode("li", null, " where a party prints out this document after all parties that are signing electronically have done so, the first print-out by that party after all signatories who are signing through DocuSign digital 'click' acceptance via the Platform or other electronic execution method or signature will also be an executed original counterpart of this document. Each signatory confirms that their signature appearing in the agreement, including any such print-out (irrespective of which party printed it), is their personal signature authenticating it.")
  ])
], -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  style: {"color":"#313731"},
  class: "mt-1"
}, "EXECUTED as an agreement", -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px","color":"#313731","display":"inline-block"} }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, " By signing or accepting below, each director or secretary (as applicable) acknowledges and accepts the terms and conditions in the Agreement. "),
    /*#__PURE__*/_createElementVNode("li", null, "By signing or accepting below, each director or secretary (as applicable) consents to electronic execution of this document (in whole or in part), represents that they hold the position or are the person named with respect to their execution and authorises any other director or secretary (as applicable) to produce a copy of this document bearing his or her signature for the purpose of signing the copy to complete its execution under section 127 of the Corporations Act. The copy of the signature appearing on the copy so executed is to be treated as his or her original signature.")
  ])
], -1))
const _hoisted_167 = { class: "row justify-content-center mx-md-0 mx-1 mb-1 mt-0" }
const _hoisted_168 = { class: "col-md-12 col-12 px-1" }
const _hoisted_169 = {
  class: "modal fade",
  id: "confirmInvestment",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_170 = { class: "modal-dialog" }
const _hoisted_171 = { class: "modal-content" }
const _hoisted_172 = { class: "modal-header" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Select Debit Account", -1))
const _hoisted_174 = { class: "modal-body" }
const _hoisted_175 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_176 = {
  id: "saveAccount",
  method: "post"
}
const _hoisted_177 = { class: "row" }
const _hoisted_178 = { class: "col-md-12" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Please select which account Caprock should debit the amount from", -1))
const _hoisted_180 = { class: "form-group" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "selected",
  value: ""
}, "Select Cash Account", -1))
const _hoisted_182 = ["value"]
const _hoisted_183 = { class: "col-md-12 mt-5" }
const _hoisted_184 = { class: "form-group d-flex justify-content-center" }
const _hoisted_185 = {
  class: "modal fade",
  id: "changeCashAc",
  tabindex: "-1",
  "aria-labelledby": "changeCashAcModalLabel",
  "aria-hidden": "true"
}
const _hoisted_186 = { class: "modal-dialog" }
const _hoisted_187 = { class: "modal-content" }
const _hoisted_188 = { class: "modal-header" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Insufficient Fund", -1))
const _hoisted_190 = { class: "modal-body" }
const _hoisted_191 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_192 = {
  id: "saveAccount",
  method: "post"
}
const _hoisted_193 = { class: "row" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", null, "There is insufficient fund in selected account, would like to select another account?")
], -1))
const _hoisted_195 = { class: "col-md-12 mt-5" }
const _hoisted_196 = { class: "form-group d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_sodipodi58namedview = _resolveComponent("sodipodi:namedview")!
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"pointer-events":"none"},
                class: "dashboard-card bg-light mb-0",
                key: ac.userac_id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(ac.ac_name), 1),
                      _hoisted_9,
                      _createElementVNode("p", _hoisted_10, [
                        _createElementVNode("b", _hoisted_11, "$" + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                      ])
                    ]),
                    (ac.default_currency_balance>0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_apexchart, {
                              type: "area",
                              height: "100",
                              options: ac.chartOptions,
                              series: ac.series
                            }, null, 8, ["options", "series"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, "$" + _toDisplayString(_ctx.total_ac_balance), 1)
              ]),
              _hoisted_18
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("h5", _hoisted_25, [
                _createElementVNode("b", null, _toDisplayString(_ctx.inv_menu['inv_name']) + " " + _toDisplayString(typeof _ctx.inv_menu['inv_investment_type'] !='undefined' ? ' - '+_ctx.inv_menu['inv_investment_type'] :''), 1)
              ])
            ])
          ]),
          (_ctx.is_invested!=0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("h5", _hoisted_27, [
                  _createElementVNode("b", _hoisted_28, "Invested " + _toDisplayString(_ctx.is_invested) + " time", 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.inv_menu['inv_name']), 1)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.inv_menu['ms_type']), 1)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.inv_menu['ms_growth']), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.inv_menu['ms_defensive']), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _hoisted_49,
                              _hoisted_50,
                              _createElementVNode("p", null, _toDisplayString(_ctx.inv_menu['ms_fund_objective']), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("table", _hoisted_53, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_54,
                                    _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.inv_menu['ms_platform']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_56,
                                    _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.inv_menu['ms_code']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_58,
                                    _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.inv_menu['ms_min_investment']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_60,
                                    _createElementVNode("th", _hoisted_61, _toDisplayString(_ctx.inv_menu['ms_inv_manager']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_62,
                                    _createElementVNode("th", _hoisted_63, _toDisplayString(_ctx.inv_menu['ms_subadvisor']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_64,
                                    _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.inv_menu['ms_risk_profile']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_66,
                                    _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.inv_menu['ms_risk_rating']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_68,
                                    _createElementVNode("th", _hoisted_69, _toDisplayString(_ctx.inv_menu['ms_fund_type']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_70,
                                    _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.inv_menu['ms_investments']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_72,
                                    _createElementVNode("th", _hoisted_73, _toDisplayString(_ctx.inv_menu['ms_sma_fees']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_74,
                                    _createElementVNode("th", _hoisted_75, _toDisplayString(_ctx.inv_menu['ms_investment_manager_fees']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_76,
                                    _createElementVNode("th", _hoisted_77, _toDisplayString(_ctx.inv_menu['ms_sub_advisor_fees']), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_78,
                                    _createElementVNode("th", _hoisted_79, _toDisplayString(_ctx.inv_menu['ms_strategy_inception_date']), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          (_ctx.target_allocations.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, [
                                  _hoisted_82,
                                  _hoisted_83,
                                  _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("table", _hoisted_85, [
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.target_allocations, (target) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: target.index
                                          }, [
                                            _createElementVNode("th", _hoisted_86, _toDisplayString(target.t), 1),
                                            _createElementVNode("td", _hoisted_87, _toDisplayString(target.a) + " %", 1)
                                          ]))
                                        }), 128)),
                                        (_ctx.target_allocation_total)
                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_88, [
                                              _hoisted_89,
                                              _createElementVNode("td", _hoisted_90, _toDisplayString(_ctx.target_allocation_total) + " %", 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (!_ctx.target_allocations.length)
                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_91, _hoisted_93))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _hoisted_94,
                                  _hoisted_95,
                                  _hoisted_96,
                                  _createElementVNode("div", _hoisted_97, [
                                    _createElementVNode("table", _hoisted_98, [
                                      _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                          _hoisted_99,
                                          _createElementVNode("td", _hoisted_100, _toDisplayString(_ctx.inv_menu['ms_growth']) + " %", 1)
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _hoisted_101,
                                          _createElementVNode("td", _hoisted_102, _toDisplayString(_ctx.inv_menu['ms_defensive']) + " %", 1)
                                        ]),
                                        _hoisted_103
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_104, [
                                  _createElementVNode("b", _hoisted_105, _toDisplayString(_ctx.inv_menu['chart_label']), 1),
                                  _hoisted_106,
                                  _createElementVNode("b", _hoisted_107, _toDisplayString(_ctx.inv_menu['ms_risk_profile']), 1),
                                  _hoisted_108,
                                  _createElementVNode("div", _hoisted_109, [
                                    (_ctx.cta_series.length)
                                      ? (_openBlock(), _createBlock(_component_apexchart, {
                                          key: 0,
                                          type: "donut",
                                          height: "350",
                                          options: _ctx.cta_chartOptions,
                                          series: _ctx.cta_series
                                        }, null, 8, ["options", "series"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.hp_series.length && _ctx.inv_menu['hp_visible']==1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                _createElementVNode("div", _hoisted_111, [
                                  _hoisted_112,
                                  _hoisted_113,
                                  _createElementVNode("div", _hoisted_114, [
                                    (_ctx.hp_series.length)
                                      ? (_openBlock(), _createBlock(_component_apexchart, {
                                          key: 0,
                                          type: "line",
                                          height: "300",
                                          options: _ctx.hp_chartOptions,
                                          series: _ctx.hp_series
                                        }, null, 8, ["options", "series"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.hp_series.length && _ctx.inv_menu['hp_visible']==1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                _createElementVNode("div", _hoisted_116, [
                                  _createElementVNode("p", null, _toDisplayString(_ctx.inv_menu['ms_hp_notes']), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_117, [
                            _createElementVNode("div", _hoisted_118, [
                              _hoisted_119,
                              _createElementVNode("p", null, _toDisplayString(_ctx.inv_menu['ms_disclaimer']), 1)
                            ]),
                            _createElementVNode("div", _hoisted_120, [
                              _hoisted_121,
                              _createElementVNode("p", null, _toDisplayString(_ctx.inv_menu['ms_copyright']), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_122, [
                            _createElementVNode("div", _hoisted_123, [
                              (_ctx.inv_menu['ms_doc_url'])
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: _ctx.inv_menu['ms_doc_url'],
                                    target: "_blank",
                                    type: "button",
                                    class: "btn btn-success btn-mobile btn-sm btn-block mt-3 btn-mobile font-size-15-18"
                                  }, " Download ", 8, _hoisted_124))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("div", _hoisted_126, [
                      _hoisted_127,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc) => {
                        return (_openBlock(), _createElementBlock("p", {
                          style: {"margin-left":"10px","padding-bottom":"4px"},
                          key: doc.doc_id
                        }, [
                          _createElementVNode("span", _hoisted_128, _toDisplayString(doc.doc_name), 1),
                          _createElementVNode("a", {
                            href: doc.doc_url,
                            target: "_blank"
                          }, [
                            _createElementVNode("span", {
                              title: 'Download ' +doc.doc_name,
                              class: "p-cursor font-size-14 font-grey float-right"
                            }, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_131, [
                                _createVNode(_component_sodipodi58namedview, {
                                  bordercolor: "#666666",
                                  borderopacity: "1",
                                  gridtolerance: "10",
                                  guidetolerance: "10",
                                  "inkscape:current-layer": "svg4",
                                  "inkscape:cx": "90.436979",
                                  "inkscape:cy": "458.00126",
                                  "inkscape:pageopacity": "0",
                                  "inkscape:pageshadow": "2",
                                  "inkscape:window-height": "667",
                                  "inkscape:window-maximized": "1",
                                  "inkscape:window-width": "1366",
                                  "inkscape:window-x": "0",
                                  "inkscape:window-y": "27",
                                  "inkscape:zoom": "0.23537234",
                                  objecttolerance: "10",
                                  pagecolor: "#ffffff",
                                  showgrid: "false"
                                }),
                                _hoisted_132
                              ]))
                            ], 8, _hoisted_130)
                          ], 8, _hoisted_129)
                        ]))
                      }), 128)),
                      (_ctx.docs.length==0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_133, _hoisted_135))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", _hoisted_137, [
                      _hoisted_138,
                      _createElementVNode("p", _hoisted_139, _toDisplayString(_ctx.inv_menu['inv_terms']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("div", _hoisted_141, [
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _createElementVNode("div", _hoisted_144, [
                            _createElementVNode("h5", _hoisted_145, [
                              _createTextVNode("Investment Application"),
                              _createElementVNode("label", _hoisted_146, "Date : " + _toDisplayString(_ctx.current_date), 1)
                            ]),
                            _hoisted_147
                          ]),
                          _createElementVNode("div", _hoisted_148, [
                            _createElementVNode("div", _hoisted_149, [
                              _createVNode(_component_CurrencyInput, {
                                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeTagErr($event))),
                                placeholder: "Amount you would like to invest",
                                modelValue: _ctx.form.amount,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.amount) = $event)),
                                "data-curency": (typeof _ctx.inv_menu['currency']!='undefined' && _ctx.inv_menu['currency']!=null) ? _ctx.inv_menu['currency']:'USD',
                                name: "amount",
                                id: "amount",
                                class: "input-border form-control selected-field",
                                options: _ctx.amount_options
                              }, null, 8, ["modelValue", "data-curency", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_150, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Your Name",
                                class: "input-border form-control selected-field",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.e_name) = $event)),
                                name: "e_name",
                                id: "e_name",
                                required: ""
                              }, null, 544), [
                                [_vModelText, _ctx.form.e_name]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_151, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Your Email Address",
                                class: "input-border form-control selected-field",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.e_email) = $event)),
                                name: "e_email",
                                id: "e_email",
                                required: ""
                              }, null, 544), [
                                [_vModelText, _ctx.form.e_email]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_152, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[6] || (_cache[6] = ($event: any) => {_ctx.checkPhone($event);}),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Your Phone Number",
                                class: "input-border form-control selected-field",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.e_phone_no) = $event)),
                                name: "e_phone_no",
                                id: "e_phone_no",
                                required: ""
                              }, null, 544), [
                                [_vModelText, _ctx.form.e_phone_no]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_153, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeTagErr($event))),
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.e_dob) = $event)),
                                type: "text",
                                placeholder: "D.O.B.",
                                onclick: "this.type='date'",
                                onfocus: "this.type='date';this.setAttribute('autocomplete','disable-autocomplete');",
                                onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                class: "input-border form-control selected-field",
                                name: "e_dob",
                                id: "e_dob",
                                required: ""
                              }, null, 544), [
                                [_vModelText, _ctx.form.e_dob]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_154, [
                            (this.confirm==1)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "p-cursor",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.confirm=0;_ctx.confirm_error=''})
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_155, [
                                    _hoisted_156,
                                    _createVNode(_component_sodipodi58namedview, {
                                      id: "base",
                                      bordercolor: "#666666",
                                      borderopacity: "1.0",
                                      "inkscape:current-layer": "layer1",
                                      "inkscape:cx": "164.85456",
                                      "inkscape:cy": "262.3356",
                                      "inkscape:document-units": "mm",
                                      "inkscape:pageopacity": "0.0",
                                      "inkscape:pageshadow": "2",
                                      "inkscape:window-height": "667",
                                      "inkscape:window-maximized": "1",
                                      "inkscape:window-width": "1366",
                                      "inkscape:window-x": "0",
                                      "inkscape:window-y": "27",
                                      "inkscape:zoom": "0.35",
                                      pagecolor: "#ffffff",
                                      showgrid: "false"
                                    }),
                                    _hoisted_157
                                  ]))
                                ]))
                              : _createCommentVNode("", true),
                            (this.confirm==0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "p-cursor",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.confirm=1;_ctx.confirm_error=''})
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_158, [
                                    _hoisted_159,
                                    _createVNode(_component_sodipodi58namedview, {
                                      id: "base",
                                      bordercolor: "#666666",
                                      borderopacity: "1.0",
                                      "inkscape:current-layer": "layer1",
                                      "inkscape:cx": "164.85456",
                                      "inkscape:cy": "262.3356",
                                      "inkscape:document-units": "mm",
                                      "inkscape:pageopacity": "0.0",
                                      "inkscape:pageshadow": "2",
                                      "inkscape:window-height": "667",
                                      "inkscape:window-maximized": "1",
                                      "inkscape:window-width": "1366",
                                      "inkscape:window-x": "0",
                                      "inkscape:window-y": "27",
                                      "inkscape:zoom": "0.35",
                                      pagecolor: "#ffffff",
                                      showgrid: "false"
                                    }),
                                    _hoisted_160
                                  ]))
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_161,
                            _createElementVNode("small", _hoisted_162, _toDisplayString(_ctx.confirm_error), 1),
                            _hoisted_163,
                            _hoisted_164,
                            _hoisted_165,
                            _hoisted_166
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_167, [
                          _createElementVNode("div", _hoisted_168, [
                            _createElementVNode("button", {
                              id: "subBtn",
                              type: "button",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.validateForm();}),
                              class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                            }, " Invest Now ")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_169, [
      _createElementVNode("div", _hoisted_170, [
        _createElementVNode("div", _hoisted_171, [
          _createElementVNode("div", _hoisted_172, [
            _hoisted_173,
            _createElementVNode("img", {
              style: {"cursor":"pointer"},
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closeModal('confirmInvestment'))),
              src: _imports_0
            })
          ]),
          _createElementVNode("div", _hoisted_174, [
            _createElementVNode("div", _hoisted_175, [
              _createElementVNode("form", _hoisted_176, [
                _createElementVNode("div", _hoisted_177, [
                  _createElementVNode("div", _hoisted_178, [
                    _hoisted_179,
                    _createElementVNode("div", _hoisted_180, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.cash_subac_id) = $event)),
                        onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.balance_cashac(_ctx.form.cash_subac_id,_ctx.form.amount))),
                        class: "form-control"
                      }, [
                        _hoisted_181,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cash_accounts, (cash) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: cash.subac_id,
                            value: cash.subac_id
                          }, _toDisplayString(cash.subac_name), 9, _hoisted_182))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.form.cash_subac_id]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_183, [
                    _createElementVNode("div", _hoisted_184, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success font-white",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.checkBalance();}),
                        style: {"padding":"6px 40px","text-align":"center"}
                      }, "Confirm")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_185, [
      _createElementVNode("div", _hoisted_186, [
        _createElementVNode("div", _hoisted_187, [
          _createElementVNode("div", _hoisted_188, [
            _hoisted_189,
            _createElementVNode("img", {
              style: {"cursor":"pointer"},
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeModal('changeCashAc'))),
              src: _imports_0
            })
          ]),
          _createElementVNode("div", _hoisted_190, [
            _createElementVNode("div", _hoisted_191, [
              _createElementVNode("form", _hoisted_192, [
                _createElementVNode("div", _hoisted_193, [
                  _hoisted_194,
                  _createElementVNode("div", _hoisted_195, [
                    _createElementVNode("div", _hoisted_196, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success font-white",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.do_debit_amount=0;_ctx.form.cash_subac_id='';_ctx.closeModal('changeCashAc');_ctx.openModal('confirmInvestment')}),
                        style: {"padding":"6px 40px","text-align":"center","margin-right":"20px"}
                      }, "Yes"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger font-white",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.closeModal('changeCashAc');_ctx.do_debit_amount=0;_ctx.submitForm();}),
                        style: {"padding":"6px 40px","text-align":"center"}
                      }, "No")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ], 64))
}